import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_INFERNO } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/invincible-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/invincible-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/invincible-extreme.guitar.json' with { type: 'json' };

export const INVINCIBLE_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'invincible',
  baseTitle: "Invincible",
  description: "DEAF KEV's NCS classic on Medievalpanda's Normal chart. Same source pattern across all three diffs — Normal thins for a clean intro, Extreme plays the full sparse map at speed.",
  difficulty: 5,
  palette: PALETTE_INFERNO,
  audioSrc: '/audio/guitar/invincible.mp3',
  attribution: "\"Invincible\" by DEAF KEV [NCS Release] - https://ncs.io/Invincible",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
